export default __webpack_public_path__ + "static/media/ico_messages.efd11e48.svg";